import TicketDepartmentAdd from "@/views/TicketDepartment/TicketDepartmentAdd";
import TicketDepartmentList from "@/views/TicketDepartment/TicketDepartmentList";
import TicketDepartmentEdit from "@/views/TicketDepartment/TicketDepartmentEdit";
import TicketList from "@/views/Ticket/TicketList";
import TicketView from "@/views/Ticket/TicketView";


const routes = [
 {
    path: '/ticketDepartment/Add',
    name: 'TicketDepartmentAdd',
    component: TicketDepartmentAdd,
    meta:{requiredAuth:true}
  },
 {
    path: '/ticketDepartment/list',
    name: 'TicketDepartmentList',
    component: TicketDepartmentList,
    meta:{requiredAuth:true}
  },
 {
    path: '/TicketDepartment/Edit/:id',
    name: 'TicketDepartmentEdit',
    component: TicketDepartmentEdit,
    meta:{requiredAuth:true}
  },
 {
    path: '/Ticket/list',
    name: 'TicketList',
    component: TicketList,
    meta:{requiredAuth:true}
  },
 {
    path: '/Ticket/View/:id',
    name: 'TicketView',
    component: TicketView,
    meta:{requiredAuth:true}
  },
]

export default routes